export const promisify = (fn, context) => (...args) => {
  let resolve, reject
  // eslint-disable-next-line promise/param-names
  const promise = new Promise((...args) => ([resolve, reject] = args))
  const cb = (err, ...rest) => (err ? reject(err) : resolve(...rest))
  fn.call(context, ...args, cb)
  return promise
}
